export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_20-0e51dd1d1203e90d2adb4c3d80d1c968.jpg";